module.exports = "<mat-card class=\"image\">\n  <img mat-card-image [src]=\"getPublicImagePath(image.pathIcon)\">\n</mat-card>\n"